import { useEffect, useState } from "react";

import * as api from "@/api/client";
import type { EmailMetricsResponse } from "@/types/api";

/**
 * Fetches the Vigil email-service status once on mount. email_service is
 * currently pending_deploy — no active polling needed. Refreshes naturally
 * on page remount or environment switch. Ported from
 * products/x2mail-admin/src/hooks/useEmailStatus.ts.
 */
export interface EmailStatusState {
  status: EmailMetricsResponse | null;
  loading: boolean;
  error: string | null;
}

export function useVigilEmailStatus(): EmailStatusState {
  const [status, setStatus] = useState<EmailMetricsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const res = await api.getVigilEmail();
        if (!cancelled) {
          setStatus(res);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "Błąd pobierania statusu email");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    void load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { status, loading, error };
}
